import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { defineConfig } from "../../config";
import { authHeader } from "../../helpers";

const PUBLIC_PAGES = ["/login", "/report/"];

/**
 * Tells the gateway which page the signed-in user opens (the activity log; the API calls are recorded there).
 * Sent without waiting and never retried: a failure must not touch the navigation.
 */
const ActivityTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        if (!localStorage.getItem("auth") || PUBLIC_PAGES.some(page => path.startsWith(page))) return;
        // the gateway of the tenant ("https://dev-api.alessiplatform.it/ale"); the endpoint is /v1/audit/page
        const { apiUrl } = defineConfig.SYSTEMS_SERVICE;
        const apiVer = "/v1";
        // after the page has its title
        const timer = setTimeout(() => {
            try {
                fetch(`${apiUrl.replace(/\/$/, "")}${apiVer}/audit/page`, {
                    method: "POST",
                    headers: authHeader("application/json"),
                    body: JSON.stringify({ path: path + location.search, title: document.title }),
                    keepalive: true,
                }).catch(() => {});
            } catch (e) {
                // never in the way of the page
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [location.pathname, location.search]);

    return null;
};

export default ActivityTracker;
